import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import MyDocument from "./MyDocument";
import { TraceOrderConsumer } from "../contexts/trace-order";
import { extractDate } from "../utils/date";

export default function PdfModal() {
  const { orderList, skipList, deliveryDate } = TraceOrderConsumer();

  return (
    <>
      <div style={downloadStyle}>
        <PDFDownloadLink document={<MyDocument ol={orderList} sl={skipList}/>} fileName={ "Orders-" + extractDate(deliveryDate) + ".pdf"}>
          {({ url, loading, error }) => {
            console.log(url, error);
            return loading ? 'Loading document...' : 'Download now!'
          }
          }
        </PDFDownloadLink>
      </div>
      <PDFViewer style={viewerStyle}>
        <MyDocument ol={orderList} sl={skipList}/>
      </PDFViewer>
    </>
  );
}

const downloadStyle = {
  display: "block",
  margin: "45 auto",
  width: "100%",
};


const viewerStyle = {
  display: "block",
  margin: "45 auto",
  width: "100%",
  height: "92vh",
};
